import clsx from 'clsx';
import { useId } from 'react';

type PropsType = {
  containerStyle?: React.CSSProperties;
  containerClass?: string;
  textStyle?: React.CSSProperties;
  textClass?: string;
  text?: string;
  children?: React.ReactNode;
  color?: string;
  strokeWidth?: string;
  strokeColor?: string;
  fontFamily?: string;
  fontSize?: string;
  lineGradient?: string[];
  lineGradientRotate?: string;
};

export default function StokeText(props: PropsType) {
  const gradientId = useId();
  const textStyle = Object.assign(
    {
      fill: props.lineGradient ? `url(#${gradientId})` : props.color,
      stroke: props.strokeColor,
      strokeWidth: props.strokeWidth,
      fontFamily: props.fontFamily,
      fontSize: props.fontSize,
    },
    props.textStyle,
  );

  return (
    <div className={clsx("relative inline-block font-semibold")}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`absolute top-[2px] left-0 w-full h-full ${props.containerClass || ''}`}
        style={props.containerStyle}
      >
        {props.lineGradient && (
          <defs>
            <linearGradient
              id={gradientId}
              gradientTransform={`rotate(${props.lineGradientRotate || 90})`}
            >
              {props.lineGradient.map((item, index, list) => (
                <stop
                  key={index}
                  stopColor={item}
                  offset={`${(index * 100) / (list.length - 1)}%`}
                ></stop>
              ))}
            </linearGradient>
          </defs>
        )}
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          className={`paint-order-stroke-fill stroke-[1.39px] ${props.textClass || ''}`}
          style={textStyle}
        >
          {props.children || props.text}
        </text>
      </svg>
      <span
        className={`relative invisible whitespace-nowrap paint-order-stroke-fill h-[11px] stroke-[1.39px] ${props.textClass || ''
          }`}
      >
        {props.children || props.text}
      </span>
    </div>
  );
}
